/**
 * Menu item component.
 *
 * Styled menu item with support for icons, active state, and checkmarks.
 */

import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import * as BloomMenu from "bloom-menu";

import { Icon } from "../icon";
import { styles } from "./menu-styles.stylex";

export interface MenuItemProps {
  children: ReactNode;
  onSelect?: () => void;
  active?: boolean;
  destructive?: boolean;
  /** Icon displayed on the left */
  icon?: ReactNode;
  /** Show checkmark on right side when active */
  showCheckmark?: boolean;
}

const checkmarkSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>`;

export function MenuItem({
  children,
  onSelect,
  active,
  destructive,
  icon,
  showCheckmark,
}: MenuItemProps) {
  return (
    <BloomMenu.Item {...(onSelect ? { onSelect } : {})}>
      <div
        {...stylex.props(
          styles.item,
          active && styles.itemActive,
          destructive && styles.itemDestructive
        )}
      >
        {icon}
        {children}
        {showCheckmark && active && (
          <Icon size="xs" svg={checkmarkSvg} xstyle={styles.checkmark} />
        )}
      </div>
    </BloomMenu.Item>
  );
}
